import { useState } from 'react';
import { useSnackbar } from 'notistack';
import { Button, TextField, Typography } from '@material-ui/core';
import { updateBillingInfo } from '../../../pages/Products/api';
import countries from '../../../components/Products/countries';
import { FormDropdown } from '../../../components/Products/FormField';
import { snackbarVariants, states } from '../../../utilities/constants';
import ButtonWithLoader from '../../../pure-ui/ButtonWithLoader/ButtonWithLoader';
const inputStyle: React.CSSProperties = {
  height: 55,
  borderRadius: 5,                 // rounder corners like Stripe
  backgroundColor: '#fff',
};


const cardLikeSection: React.CSSProperties = {
  border: '1px solid #E5E7EB',
  borderRadius: 12,
  padding: 16,
  background: '#fff',
};

const BillingDetails = (props) => {
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setisLoading] = useState(false);
  const [submitError, setSubmitError] = useState(null);
  const { billingInfo, setBillingInfo, showSubmitButton } = props;
  const [isProcessCompleted, setisProcessCompleted] = useState(false);
  const [prevBillingInfo, setPrevBillingInfo] = useState(billingInfo);
  const [disabled, setDisabled] = useState(showSubmitButton ? true : false);

  const onChange = (e) => {
    setBillingInfo({ ...billingInfo, [e.target.name]: e.target.value });
  };

  const setPaymentState = (selectedState) => {
    setBillingInfo({ ...billingInfo, paymentState: selectedState.value });
  };

  const findStateByValue = (value) => {
    const state = states.find((state) => state.value === value);
    return state?.label;
  };

  const setPaymentCountry = (selectedCountry) => {
    if (selectedCountry.value === 'US') {
      setBillingInfo({ ...billingInfo, paymentCountry: selectedCountry.value });
    } else {
      setBillingInfo({
        ...billingInfo,
        paymentCountry: selectedCountry.value,
        paymentState: '',
      });
    }
  };

  const findCountryByValue = (value) => {
    const country = countries.find((country) => country.value === value);
    return country?.label || value;
  };

  return (
    <div className="flex flex-col w-full items-center">

      {/* Stripe-like card container */}
      <div className="w-full max-w-[560px]" style={cardLikeSection}>
        <Typography variant="h6" gutterBottom>
          Card Biiling Information
        </Typography>
        {/* Full name */}
        <div className="w-full mb-4">
          <TextField
            name="name"
            placeholder="Full name"
            value={billingInfo?.name ?? ''}
            onChange={onChange}
            size="small"
            margin="none"
            fullWidth
            variant="outlined"
            InputProps={{ style: inputStyle }}
          />
        </div>

        {/* Address line 1 */}
        <div className="w-full mb-4">
          <TextField
            name="paymentAddress"
            placeholder="Street address"
            value={billingInfo?.paymentAddress ?? ''}
            onChange={onChange}
            size="small"
            margin="none"
            fullWidth
            variant="outlined"
            InputProps={{ style: inputStyle }}
          />
        </div>

        {/* Address line 2 (optional) */}
        <div className="w-full mb-4">
          <TextField
            name="paymentAddress2"
            placeholder="Apartment, suite, etc."
            value={billingInfo?.paymentAddress2 ?? ''}
            onChange={onChange}
            size="small"
            margin="none"
            fullWidth
            variant="outlined"
            InputProps={{ style: inputStyle }}
          />
        </div>

        {/* Two-column row: City, ZIP */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
          <div className="w-full">
            <TextField
              name="paymentCity"
              placeholder="City"
              value={billingInfo?.paymentCity ?? ''}
              onChange={onChange}
              size="small"
              margin="none"
              fullWidth
              variant="outlined"
              InputProps={{ style: inputStyle }}
            />
          </div>
          <div className="w-full">
            <TextField
              name="paymentZIP"
              placeholder="ZIP / Postal code"
              value={billingInfo?.paymentZIP ?? ''}
              onChange={onChange}
              size="small"
              margin="none"
              fullWidth
              variant="outlined"
              InputProps={{ style: inputStyle }}
            />
          </div>
        </div>

        {/* Country */}
        <div className="w-full mb-4">
          <FormDropdown
            type="countries"
            name="paymentCountry"
            label="Country"
            placeholder={
              billingInfo?.paymentCountry
                ? findCountryByValue(billingInfo?.paymentCountry)
                : 'Select... (required *)'
            }
            selectedOption={billingInfo?.paymentCountry}
            onChange={setPaymentCountry}
          />
        </div>

        {/* State (US only) */}
        {billingInfo?.paymentCountry === 'US' && (
          <div className="w-full">
            <FormDropdown
              type="states"
              name="paymentState"
              label="State"
              placeholder={
                billingInfo?.paymentState
                  ? findStateByValue(billingInfo?.paymentState)
                  : 'Select...'
              }
              selectedOption={billingInfo?.paymentState}
              onChange={setPaymentState}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default BillingDetails;
